module.exports = __webpack_public_path__ + "media/images/branding/coco_logo_1-8398e152b142ca82bcf6c1a9f188c9f4.png";